__turbopack_context__.v({
  "avatar": "RaGe_G_avatar",
  "avatarWrapper": "RaGe_G_avatarWrapper",
  "listItem": "RaGe_G_listItem",
  "shopText": "RaGe_G_shopText",
  "textContainer": "RaGe_G_textContainer",
  "userItem": "RaGe_G_userItem",
  "username": "RaGe_G_username",
});
